(function () {
  function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
      y = direction * 100;

    if (elem.classList.contains("gs-reveal-left")) {
      x = -100;
      y = 0;
    } else if (elem.classList.contains("gs-reveal-right")) {
      x = 100;
      y = 0;
    }

    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";

    gsap.fromTo(
      elem,
      { x: x, y: y, autoAlpha: 0 },
      {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto",
      }
    );
  }

  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
  }

  function imgSequence(idSelector, frameCount, imgPath, scrollTriggerOptions) {
    const imgExtension = Modernizr.webp.alpha ? "webp" : "jpg";
    const images = [];
    var canvas = document.getElementById(idSelector);

    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      scaleToFill(images[frames.frame]);
      //console.log(idSelector, frames.frame);
    }

    function scaleToFill(img) {
      var scale = Math.max(canvas.width / img.width, canvas.height / img.height);
      var x = canvas.width / 2 - (img.width / 2) * scale;
      var y = canvas.height / 2 - (img.height / 2) * scale;

      context.drawImage(img, x, y, img.width * scale, img.height * scale);
    }

    function windowResize() {
      canvas.width = canvas.parentElement.getBoundingClientRect().width;
      canvas.height = canvas.parentElement.getBoundingClientRect().height;

      render();
    }

    if (canvas) {
      var context = canvas.getContext("2d");
      var frames = { frame: 0 };
      var currentFrame = (index) => {
        return imgPath.replace(/{{ext}}/g, imgExtension).replace("{{index}}", index.toString().padStart(3, "0"));
      };

      for (var i = 0; i < frameCount; i++) {
        var img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      gsap.to(frames, {
        frame: frameCount - 1,
        snap: "frame",
        scrollTrigger: scrollTriggerOptions,
        onUpdate: render, // use animation onUpdate instead of scrollTrigger's onUpdate
      });

      images[0].onload = render;

      window.addEventListener("resize", windowResize);
      windowResize();
    }
  }

  function curtainReveal() {
    var el = document.querySelector(".theme-header");
    var img = el.querySelector("img");

    img.onload = function () {
      el.classList.add("loaded");
    };

    img.src = img.currentSrc || img.src;
  }

  document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    Modernizr.on("webp", function (result) {
      imgSequence("bottom-view", 140, window.location.origin + "/images/1-scroll-view-to-bottom/{{ext}}/NOVY Pureline Frame Dampkap_scroll_view_to_bottom_{{index}}.{{ext}}", {
        trigger: ".section-view",
        scrub: true,
        start: "top top",
        pin: ".section-view .text-wrapper",
      });

      imgSequence("deconstruct", 129, window.location.origin + "/images/3-scroll-to-components/{{ext}}/NOVY Pureline Frame Dampkap_scroll_To_Components_{{index}}.{{ext}}", {
        trigger: ".section-deconstruct",
        scrub: 0.5,
        start: "top top",
        pin: ".section-deconstruct .text-wrapper",
      });
    });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".section-view",
        scrub: 1,
        snap: true,
        start: "top top",
        end: "bottom bottom",
      },
    });

    tl.from(".section-view .one", { y: 0, opacity: 1 });
    tl.to(".section-view .one", { y: -100 + "vh", opacity: 0 });
    tl.from(".section-view .two", { y: 100, opacity: 0 });
    tl.to(".section-view .two", { y: 0 + "vh", opacity: 1 });

    var tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".section-deconstruct",
        scrub: 1,
        snap: 1 / 5,
        start: "top top",
        end: "bottom bottom",
      },
    });

    tl2.from(".section-deconstruct .one", { y: 0, opacity: 1 });
    tl2.to(".section-deconstruct .one", { y: -100 + "vh", opacity: 0 });

    tl2.from(".section-deconstruct .two", { y: 100 + "vh", opacity: 0 });
    tl2.to(".section-deconstruct .two", { y: 0 + "vh", opacity: 1 });
    tl2.to(".section-deconstruct .two", { y: -100 + "vh", opacity: 0 });

    tl2.from(".section-deconstruct .three", { y: 100 + "vh", opacity: 0 });
    tl2.to(".section-deconstruct .three", { y: 0 + "vh", opacity: 1 });
    tl2.to(".section-deconstruct .three", { y: -100 + "vh", opacity: 0 });

    tl2.from(".section-deconstruct .four", { y: 100 + "vh", opacity: 0 });
    tl2.to(".section-deconstruct .four", { y: 0 + "vh", opacity: 1 });
    tl2.to(".section-deconstruct .four", { y: -100 + "vh", opacity: 0 });

    tl2.from(".section-deconstruct .five", { y: 100 + "vh", opacity: 0 });
    tl2.to(".section-deconstruct .five", { y: 0 + "vh", opacity: 1 });
    tl2.to(".section-deconstruct .five", { y: -100 + "vh", opacity: 0 });

    tl2.from(".section-deconstruct .six", { y: 100 + "vh", opacity: 0 });
    tl2.to(".section-deconstruct .six", { y: 0 + "vh", opacity: 1 });
    //tl2.to('.six', { y: -100 + 'vh', opacity: 0 });

    var tl3 = gsap.timeline({
      scrollTrigger: {
        trigger: ".intro-section",
        scrub: 1,
        snap: true,
        start: "top top",
        end: "center center",
      },
    });

    //tl3.from('.intro-img img', { scale: 0.75, x: 0, y: 0 });
    //tl3.to('.intro-img img', { scale: 1, x: 0, y: 0 });

    if (window.screen.width >= 992) {
      gsap.utils.toArray(".gs-reveal").forEach(function (elem) {
        hide(elem); // assure that the element is hidden when scrolled into view

        ScrollTrigger.create({
          trigger: elem,
          onEnter: function () {
            animateFrom(elem);
          },
          onEnterBack: function () {
            animateFrom(elem, -1);
          },
          onLeave: function () {
            hide(elem);
          }, // assure that the element is hidden when scrolled into view
        });
      });

      var arrSnapping = gsap.utils.toArray(".g-snapping");
      arrSnapping.forEach((section) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top top",
          snap: 1,
        });
      });
    }

    var arrSections = gsap.utils.toArray(".g-pinning");
    arrSections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        pin: true,
        pinSpacing: false,
      });
    });

    curtainReveal();
  });
})();
